import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { OrdenCarroComponent } from './orden-carro.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        component: OrdenCarroComponent,
      },
      { path: '**', redirectTo: '' },
    ],
  },
];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OrdenCarroComponentRoutingModule {}
